import api from './api';
import store from '@/store';
import _ from 'lodash';

export default {
  get(id, fields) {
    return new Promise((resolve, reject) => {
      let params = {
        fields
      };
      api
        .get('referral/find/' + id, { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getPage(page, pageSize, orderby, search, searchFilters, terms, ranges, dates, fields) {
    let filters = {};

    if (!_.isEmpty(searchFilters)) {
      filters = {
        ...filters,
        ...searchFilters
      };
    }

    fields = { ...fields };

    search = search.trim();

    let re = new RegExp('^[\\+]?[0-9\\s]*$');
    if (re.test(search)) {
      // This looks like a phone number search, so treat it as one and make it a single search term with infix matching (e.g. *01234*567890*)
      search = search
        .split(' ')
        .filter(Boolean)
        .join('*');
    } else {
      // Otherwise, split it up and infix match it (as it would be on a single term; clifton -> *clifton*, clifton asset -> *clifton* *asset*)
      // The alternative is that it would end up becoming *clifton asset* which has a whole bunch of different semantic meaning.
      search = search
        .split(' ')
        .filter(Boolean)
        .join('* *');
    }

    search = search ? `*${search}*` : '';

    let params = {
      paginate: pageSize,
      page,
      orderby,
      search,
      filters,
      terms,
      ranges,
      dates,
      fields
    };

    return api
      .get('referral/search', { params })
      .then(response => response.data)
      .catch(error => {
        throw error.data;
      });
  },
  getReferral(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`referral/${id}`, {
          params: {
            includes: 'owner,creator,account.businesses'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  downloadReferrals(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`referral/${id}/download`, { responseType: 'blob' })
        .then(response => resolve(response))
        .catch(error => reject(error.data));
    });
  },
  updateReferral(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`referral/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addReferral(referral) {
    referral.user_id = store.getters.UserId;
    return new Promise((resolve, reject) => {
      api
        .post(`referral`, referral)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  uploadReferral(files, businessId) {
    const data = new FormData();
    data.append('business_id', businessId);
    data.append('referrals', files[0]);
    data.append('user_id', store.getters.UserId);

    return new Promise((resolve, reject) => {
      api
        .post(`referral/upload`, data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getReferralActivity(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`activity`, {
          params: {
            orderby: 'created_at,desc',
            filters: {
              where: [
                ['subject_id', '=', id],
                ['subject_type', '=', 'App\\Models\\Referral']
              ]
            }
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  postReferralComment(id, comment, privacy) {
    return new Promise((resolve, reject) => {
      api
        .post('activity', {
          subject_id: id,
          subject_type: 'referral',
          comment: comment,
          privacy: privacy
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  createFromCustomer(id, businessId) {
    return new Promise((resolve, reject) => {
      api
        .post('referral/from-customer', {
          id: id,
          business_id: businessId
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
